// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__RtImj","label":"Labeled_label__1qjgG","divider":"Labeled_divider__6IPTX"};